module.exports = __webpack_public_path__ + "0955f3cb693704c1eab7ce5d298b4df6.png";